export type UserType = {
  isAnonymous: boolean;
  isGuest: boolean;
  isAuthenticatedUser: boolean;
};

/**
 * Classify the viewer from their loaded profile. Three mutually exclusive kinds:
 * anonymous (no profile — public-share viewer), OTP guest (`role === 'guest'`),
 * and full authenticated user. Loading counts as anonymous (nothing granted yet).
 */
export const resolveUserType = (profile: any, profileLoading: boolean): UserType => {
  if (profileLoading || !profile) {
    return { isAnonymous: true, isGuest: false, isAuthenticatedUser: false };
  }

  const isGuest = profile.user?.role === 'guest';

  return { isAnonymous: false, isGuest, isAuthenticatedUser: !isGuest };
};
